module.exports = __webpack_public_path__ + "static/media/POPCORN_3.59fabaea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/POPCORN_3.png
// module id = 186
// module chunks = 0